import { render, staticRenderFns } from "./ComponentLabelWithHorizontalLines.vue?vue&type=template&id=6bbafc84&"
import script from "./ComponentLabelWithHorizontalLines.vue?vue&type=script&lang=ts&"
export * from "./ComponentLabelWithHorizontalLines.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentLabelWithHorizontalLines.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports